"use client";

import dynamic from 'next/dynamic';
import type { PageUrlMap } from '@/types/blog';

const ProfileMenu = dynamic(() => import('./ProfileMenu'), {
  ssr: false,
});

interface ProfileMenuWrapperProps {
  pageUrls?: PageUrlMap;
  /** Artık kullanılmıyor - Layout'taki CustomerAuthProvider tek kaynaktır. Geriye dönük uyumluluk için bırakıldı. */
  initialCustomer?: unknown;
  /** Artık kullanılmıyor. Geriye dönük uyumluluk için bırakıldı. */
  noSessionOnServer?: boolean;
}

/**
 * Header'daki profil menüsü. Layout'taki CustomerAuthProvider'ı kullanır;
 * giriş yapıldığında state tek provider'da güncellenir ve profil bilgileri doğru gösterilir.
 */
export default function ProfileMenuWrapper({ 
  pageUrls = {}, 
}: ProfileMenuWrapperProps) {
  return <ProfileMenu pageUrls={pageUrls} />;
}
